import H_time from '@/helpers/time';

export default {
  setShow(rawData) {
    const {
      id,
      retention_days,
      frequency,
      backup_days,
      backup_time,
      next_backup_at,
      updated_at,
      updated_user,
    } = rawData || {};
    return {
      id: id ?? null,
      retentionDays: retention_days ?? null,
      backupFrequencyDays: frequency ?? null,
      backupDays: backup_days ?? null,
      backupTime: backup_time ? H_time.getDateDashFormat(backup_time, 'HH:mm') : null,
      nextBackupAt: next_backup_at
        ? H_time.getDateDashFormat(next_backup_at, 'YYYY-MM-DD HH:mm')
        : null,
      updatedAt: H_time.getDateDashFormat(updated_at, 'YYYY-MM-DD HH:mm:ss'),
      updatedUser: updated_user || null,
    };
  },
  // backup_time 後端要完整時間含時區；日期用今天，時間來自表單的 HH:mm
  setUpdateData({ retentionDays, backupFrequencyDays, backupDays, backupTime }) {
    const today = H_time.getDateDashFormat(new Date());
    return {
      retention_days: Number(retentionDays),
      frequency: Number(backupFrequencyDays),
      backup_days: Number(backupDays),
      backup_time: H_time.getDateDashFormat(`${today} ${backupTime}`, 'YYYY-MM-DDTHH:mm:ssZ'),
    };
  },
};
